import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
const services = [{
  name: 'Close CRM Consulting',
  subtitle: 'For a quick start',
  description: 'Perfect for companies that want to use Close CRM themselves and need a professional start.',
  price: '',
  features: ['Close CRM Account Setup', 'Pipeline Configuration (up to 1 pipeline)', 'Basic Automations', 'Data Migration Consulting', '1-on-1 Consulting', '4 weeks of twice-weekly 1-on-1 consulting calls', 'Automation Templates'],
  cta: 'Request Pricing',
  highlighted: false
}, {
  name: 'Close CRM Set Up',
  subtitle: 'Our Bestseller',
  description: 'The complete solution for companies that want maximum results with minimal effort.',
  price: '',
  features: ['Everything in Close CRM Consulting', 'Pipeline Configuration (up to 3 pipelines)', 'Advanced Automations', 'Data Migration (unlimited contacts)', 'All Integrations (Make, Zapier, API)', 'Telephony Setup incl. numbers', 'Custom Reporting Dashboards', 'Intensive Training (4 hours)', '30 Days Priority Support'],
  cta: 'Request Pricing',
  highlighted: true
}, {
  name: 'Managed Service',
  subtitle: 'All-inclusive',
  description: 'We take over the complete CRM administration so you can focus on selling.',
  price: '',
  features: ['Everything in Close CRM Set Up', 'Dedicated Account Manager', 'Ongoing Process Optimization', 'New Automations on demand', 'Unlimited Support', 'Monthly Performance Reports', 'Monthly Optimization Calls', 'Prioritized Feature Requests', 'SLA with 4h response time'],
  cta: 'Request Pricing',
  highlighted: false
}];
export function ServicesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 lg:py-32 bg-[#0a0a0a]" id="services" ref={ref} data-id="element-258" data-mp="3najz6vxo9lg0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259" data-mp="3s1s9rvaqncur">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-260" data-mp="3s2k7pcrt5mo7">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6" data-id="element-261" data-mp="399psqiu6pujz">
            Our Services
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-262" data-mp="oluz7l8o02vw">
            Custom Close CRM Implementation
          </h2>
          <p className="mt-6 text-lg text-gray-400" data-id="element-263" data-mp="tm98t7pwzkw1">
            Choose the package that fits your needs. Each package is
            individually customizable.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8" data-id="element-264" data-mp="29575whsd47w7">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className={`relative rounded-2xl ${service.highlighted ? 'bg-gradient-to-b from-[#0ea5e9]/20 to-[#1a1a1a] border-2 border-[#0ea5e9]/50' : 'bg-[#1a1a1a] border border-white/5'}`} data-id="element-265" data-mp="24aazgcmdphzk" data-mpi={index}>
              {service.highlighted && <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-266" data-mp="3aqdacxvjj6t5">
                  <span className="inline-flex items-center gap-1 px-4 py-1.5 rounded-full bg-[#0ea5e9] text-white text-sm font-semibold" data-id="element-267" data-mp="28fjsygtdui5h">
                    <SparklesIcon className="w-4 h-4" data-id="element-268" data-mp="1yguiva7qa1zs" />
                    Most Popular
                  </span>
                </div>}

              <div className="p-8" data-id="element-269" data-mp="23ennvzxaopyh">
                <div className="mb-6" data-id="element-270" data-mp="23hs0nlotsu0r">
                  <h3 className="text-2xl font-bold text-white" data-id="element-271" data-mp="1oqsu0g7jwfjt">
                    {service.name}
                  </h3>
                  <p className="text-[#0ea5e9] text-sm font-medium mt-1" data-id="element-272" data-mp="1tiklcsyj6pb0">
                    {service.subtitle}
                  </p>
                </div>

                <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-273" data-mp="1kp7l15y50lew">
                  {service.description}
                </p>

                <div className="mb-8" data-id="element-274" data-mp="15thxh3db0082">
                  <span className="text-4xl font-bold text-white" data-id="element-275" data-mp="15ujahddvqwsf">
                    {service.price}
                  </span>
                </div>

                <ul className="space-y-3 mb-8" data-id="element-276" data-mp="r6j618eg55tc">
                  {service.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-277" data-mp="n57pdsdjvuxa" data-mpi={i}>
                      <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-278" data-mp="11474o9f6axgs">
                        <CheckIcon className="w-3 h-3 text-emerald-400" data-id="element-279" data-mp="w2zvc5xdtq80" />
                      </div>
                      <span className="text-gray-300 text-sm" data-id="element-280" data-mp="1a2stunf5haqj">{feature}</span>
                    </li>)}
                </ul>

                <a href="/free-strategy-call" className={`group w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-lg font-semibold transition-all duration-200 ${service.highlighted ? 'bg-[#0ea5e9] text-white hover:bg-[#0284c7] shadow-lg shadow-[#0ea5e9]/25' : 'bg-white/5 text-white border border-white/10 hover:bg-white/10'}`} data-id="element-281" data-mp="1ju5kjbp7puuz">
                  {service.cta}
                  <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-282" data-mp="1vxhqp5jitdg5" />
                </a>
              </div>
            </motion.div>)}
        </div>

        {/* Custom solution CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-283" data-mp="25tban9zkk97y">
          <p className="text-gray-400" data-id="element-284" data-mp="2olx2lj7cvfn9">
            Need a custom solution?{' '}
            <a href="/free-strategy-call" className="text-[#0ea5e9] hover:underline font-medium" data-id="element-285" data-mp="2tivwc0n3xkkx">
              Talk to us →
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}